import { createApi } from '@reduxjs/toolkit/query/react'

import envConfig from '~/configs/env'

import anonymizingFetchBaseQuery from '../anonymizingBaseQuery'
import prepareAuthHeader from '../headers'

const baseQuery = anonymizingFetchBaseQuery({
  baseUrl: envConfig.serviceUrls.fleet,
  prepareHeaders: prepareAuthHeader
})

// eslint-disable-next-line import/prefer-default-export
export const api = createApi({
  reducerPath: 'fleetGatewayApi',
  baseQuery,
  endpoints: () => ({})
})
